import React from 'react'
import styles from './PostPreviewCard.module.scss'
import useUserImage from '../../../../../hooks/useUserImage.js'

interface PostPreviewCardProps {
  content: string
  userData?: {
    id?: number | string
    name?: string
    last_name?: string
    razon_social?: string
    type?: 'COMPANY' | 'PERSON'
    image_profile?: string
  }
  imagePreviewUrl?: string | null
}

const PostPreviewCard: React.FC<PostPreviewCardProps> = ({
  content,
  userData,
  imagePreviewUrl
}) => {
  const completeName = userData?.type === 'COMPANY'
    ? (userData.razon_social ?? '')
    : `${userData?.name ?? ''} ${userData?.last_name ?? ''}`.trim() || 'Vos'
  const { initials, profileImage, imageError } = useUserImage(userData ?? { id: '' })

  return (
    <div className={styles.previewCard}>
      <div className={styles.previewHeader}>
        <div className={styles.previewAvatar}>
          {!imageError && profileImage ? (
            <img src={profileImage} alt="" className={styles.previewAvatarImg} />
          ) : initials ? (
            <div className={styles.previewAvatarInitials}>{initials}</div>
          ) : (
            <div className={styles.previewAvatarPlaceholder} />
          )}
        </div>
        <div className={styles.previewMeta}>
          <span className={styles.previewName}>{completeName}</span>
          <span className={styles.previewBadge}>Vista previa</span>
        </div>
      </div>
      {content && (
        <div className={styles.previewContent}>
          {content.split('\n').map((line, i) => (
            <p key={i}>{line || '\u00A0'}</p>
          ))}
        </div>
      )}
      {imagePreviewUrl && (
        <div className={styles.previewImage}>
          {imagePreviewUrl.startsWith('data:video/') ? (
            <video src={imagePreviewUrl} controls />
          ) : (
            <img src={imagePreviewUrl} alt="" />
          )}
        </div>
      )}
    </div>
  )
}

export default PostPreviewCard
